import { map } from 'rxjs';
import crudStream from 'streams/crudStream/crudStream';
import { Asset, BaseAsset } from 'types';
import { parseIntSafely } from 'utils/numberUtils';

const [actions, assetRoutines, rawAsset$, assetState$] = crudStream<
  BaseAsset,
  Asset
>('asset', '/asset');


export const asset$ = rawAsset$.pipe(
  map(({ byId }) => ({
    byId: Object.fromEntries(Object.entries(byId).map(([key, item]) => [key, ({ ...item, order: parseIntSafely(item.order) })]))
  }))
)

export { actions, assetRoutines, assetState$, rawAsset$ };

